<template>
  <v-app>
    <toolbar></toolbar>
    <v-content>
      <div>
        <v-alert
          v-model="errorMessage"
          type="error"
          v-t="'error.unknown'"
          dismissible
        >
        </v-alert>
      </div>
      <v-dialog v-model="errorDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span>{{ errorDialogMessage }}</span>
          </v-card-title>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="errorDialogMessage=''">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <help-dialog></help-dialog>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <qrcode-reader
            v-if="$store.state.camera"
            @init="onCameraInit"
            @decode="onCameraDecode"
            :paused="paused"
          ></qrcode-reader>
          <v-card v-if="loading">
            <v-card-title primary-title>
              <div>
                <div class="headline" v-t="'loading'"></div>
              </div>
            </v-card-title>
          </v-card>
          <v-card v-if="!loading && qrcode && !$store.state.camera">
            <v-card class="result">
              <div class="qrcode-info">
                <div class="qrcode-area">
                  <img :src="qrcode" alt="QRCode" id="qrcode"/>
                  <div
                    v-if="$store.state.characterIcon"
                    id="character"
                    :style="{'background-image':'url('+$store.state.characterIcon+')'}"
                  ></div>
                </div>
                <div class="amount_viewer" v-if="checkAmountNumber() && amount > 0">
                  <p v-t="{path: 'amount_view', args: {amount: useFiat ? fiat : amount, amount_type: useFiat ? amountType : 'VIPS'}}"></p>
                </div>
                <div class="uri_viewer">
                  <p><a :href="uri">{{ uri }}</a></p>
                </div>
                <div class="nukumolink_viewer">
                  <p><a :href="nukumolink" target="_blank">{{ nukumolink }}</a></p>
                </div>
                <div class="notice" v-if="useFiat && checkAmountNumber() && amount > 0">
                  <p v-t="'proprietary_spec'"></p>
                </div>
              </div>
            </v-card>
            <v-container>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    id="address"
                    name="address"
                    :label="$t('address')"
                    v-model="address"
                   :rules="[
                      () => checkValidAddress() || $t('error.required_valid_address')
                    ]"
                    maxlength="34"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <character-selector></character-selector>
              <v-layout row>
                <v-flex xs12>
                  <v-select
                    :items="fiatList"
                    v-model="amountType"
                    :label="$t('fiat_list')"
                    autocomplete
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-switch
                    :label="$t('use_fiat', {amount_type: useFiat ? amountType : 'VIPS'})"
                    v-model="useFiat"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs18>
                  <v-text-field
                    id="fiatRate"
                    name="fiatRate"
                    :label="$t('rate')"
                    v-model="fiatRate"
                    type="number"
                   :rules="[
                      () => checkFiatRateNumber() || $t('error.required_number')
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>{{ amountType }}/VIPS</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs10>
                  <v-text-field
                    id="amount"
                    name="amount"
                    :label="$t('amount')"
                    v-model="amount"
                    @focus="onAmount"
                    type="number"
                   :rules="[
                      () => checkAmountNumber() || $t('error.required_number')
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-subheader>VIPS</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs10>
                  <v-text-field
                    id="fiat"
                    name="fiat"
                    :label="$t('fiat')"
                    v-model="fiat"
                    @focus="onFiat"
                    type="number"
                    :rules="[
                      () => checkFiatNumber() || $t('error.required_number')
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-subheader>{{ amountType }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    id="message"
                    name="message"
                    :label="$t('message')"
                    v-model="message"
                    maxlength="50"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-content>
  </v-app>
</template>

<style>
.result {
  padding-top: 1em;
  padding-bottom: 3em;
}

div.qrcode-area {
  margin: 0 auto;
  text-align: center;
}

div.qrcode-area {
  width: 200px;
  height: 200px;
  position: relative;
}

#qrcode {
  width: 100%;
  height: 100%;
}

#character {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 80px;
  left: 80px;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

div.amount_viewer,
div.uri_viewer,
div.nukumolink_viewer,
div.notice {
  width: 100%;
  text-align: center;
  overflow: wrap;
  overflow-wrap: break-word;
}
div.amount_viewer p,
div.notice p {
  font-weight: bold;
  font-size: 1.5em;
}
.qrcode_list {
  height: 400px;
}
</style>

<script>
import BigNumber from 'bignumber.js'
import bip21 from 'bip21'
import qrcode from 'qrcode'

import {
  address
} from 'bitcoinjs-lib'

import CharacterSelector from './components/CharacterSelector'
import HelpDialog from './components/HelpDialog'
import Toolbar from './components/Toolbar'
const BIP21URN = 'vipstarcoin'

const myQRCode = require('./assets/myqrcode.png')

export default {
  components: {
    CharacterSelector,
    HelpDialog,
    Toolbar
  },
  data () {
    return {
      myqrcode: myQRCode,
      fiatList: [
        'AUD', 'BRL', 'CAD', 'CHF', 'CLP',
        'CNY', 'CZK', 'DKK', 'EUR', 'GBP',
        'HKD', 'HUF', 'IDR', 'ILS', 'INR',
        'JPY', 'KRW', 'MXN', 'MYR', 'NOK',
        'NZD', 'PHP', 'PKR', 'PLN', 'RUB',
        'SEK', 'SGD', 'THB', 'TRY', 'TWD',
        'USD', 'ZAR'
      ]
    }
  },
  mounted: function () {
    if (window.location.host.indexOf('github.io') > -1 && window.location.protocol === 'http:') {
      window.location.protocol = 'https'
    }
    this.$store.dispatch('refreshFiat').then(() => {
      this.updateURI()
      this.$store.commit('toggleLoading')
    })
  },
  methods: {
    updateURI: function () {
      if (
        !this.checkValidAddress(this.address) ||
        !this.checkAmountNumber()
      ) {
        return
      }
      let opt = {}
      if (this.message !== '') opt.message = this.message
      if (this.useFiat && this.fiat !== '' && this.fiat !== '0') {
        opt.amount = this.amount
        opt.amountExt = this.fiat
        opt.amountType = this.amountType
      } else if (this.amount !== '' && this.amount !== '0') {
        opt.amount = this.amount
      }
      this.uri = bip21.encode(this.address, opt, BIP21URN)
    },
    updateQRCode: function () {
      if (!this.uri) return
      return new Promise((resolve, reject) => {
        qrcode.toDataURL(
          this.uri,
          {
            errorCorrectionLevel: 'Q',
            type: 'image/png'
          },
          (err, uri) => {
            if (err !== null) {
              reject(err)
            } else {
              resolve(uri)
            }
          }
        )
      }).then(uri => {
        return new Promise((resolve, reject) => {
          this.qrcode = uri
          resolve()
        })
      })
    },
    onAmount: function () {
      this.focused = 'amount'
    },
    onFiat: function () {
      this.focused = 'fiat'
    },
    checkValidAddress: function () {
      if (this.address[0] !== 'V') {
        return false
      }
      try {
        address.fromBase58Check(this.address)
        return true
      } catch (e) {
        return false
      }
    },
    checkFiatRateNumber: function () {
      if (this.fiatRate.match(/^([1-9]\d*|0)(\.\d+)?$/) || this.fiatRate === '') {
        return true
      }
      return false
    },
    checkAmountNumber: function () {
      if (this.amount.match(/^([1-9]\d*|0)(\.\d+)?$/) || this.amount === '') {
        return true
      }
      return false
    },
    checkFiatNumber: function () {
      if (this.fiat.match(/^([1-9]\d*|0)(\.\d+)?$/) || this.fiat === '') {
        return true
      }
      return false
    },
    onCameraInit: function (promise) {
      promise.then(() => {
        this.paused = false
      }).catch(error => {
        this.paused = true
        this.$store.commit('setCamera', false)
        console.error(error)
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
          this.errorDialogMessage = error.message
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
          this.errorDialogMessage = error.message
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
          this.errorDialogMessage = error.message
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
          this.errorDialogMessage = error.message
        } else if (error.name === 'OverconstrainedError') {
          // passed constraints don't match any camera. Did you requested the front camera although there is none?
          this.errorDialogMessage = error.message
        } else {
          // browser is probably lacking features (WebRTC, Canvas)
          this.errorDialogMessage = error.message
        }
      })
    },
    onCameraDecode: function (content) {
      try {
        let decode = bip21.decode(content, BIP21URN)
        this.address = decode.address
        if (decode.options.message) this.message = decode.options.message
        if (decode.options.amountExt && decode.options.amountType) {
          this.fiat = decode.options.amountExt
          this.useFiat = true
          this.amountType = decode.options.amountType
          let fiat = new BigNumber(decode.options.amountExt)
          let amount = fiat.dividedBy(this.fiatRate)
          if (amount.toString() === 'NaN') {
            this.amount = '0'
          } else {
            this.amount = amount.decimalPlaces(8).toString()
          }
        } else if (decode.options.amount) {
          this.amount = decode.options.amount
        }
      } catch (error) {
        console.error(error)
        this.errorDialogMessage = error.message
      }
      this.paused = true
      this.$store.commit('setCamera', false)
    }
  },
  computed: {
    address: {
      get () {
        return this.$store.state.address
      },
      set (value) {
        this.$store.commit('setAddress', value)
        this.updateURI()
      }
    },
    amount: {
      get () {
        return this.$store.state.amount
      },
      set (value) {
        this.$store.commit('setAmount', value)
        if (this.focused !== 'amount') {
          return
        }
        let amount = new BigNumber(value)
        let fiat = amount.multipliedBy(this.fiatRate)
        if (fiat.toString() === 'NaN') {
          this.fiat = ''
        } else {
          this.fiat = fiat.toString()
        }
        if (this.fiat === '0') {
          this.fiat = ''
        }
        this.updateURI()
      }
    },
    amountType: {
      get () {
        return this.$store.state.amountType
      },
      set (value) {
        this.$store.dispatch('refreshFiat', value).then(() => {
          this.updateURI()
        })
      }
    },
    errorDialog: {
      get () {
        return this.$store.state.errorDialog
      },
      set (value) {
      }
    },
    errorDialogMessage: {
      get () {
        return this.$store.state.errorDialogMessage
      },
      set (value) {
        this.$store.commit('setErrorDialog', value)
      }
    },
    errorMessage: {
      get () {
        return this.$store.state.errorMessage
      },
      set (value) {
        this.$store.commit('errorMessage', value)
      }
    },
    fiat: {
      get () {
        return this.$store.state.fiat
      },
      set (value) {
        this.$store.commit('setFiat', value)
        if (this.focused !== 'fiat') {
          return
        }
        let fiat = new BigNumber(value)
        let amount = fiat.dividedBy(this.fiatRate)
        if (amount.toString() === 'NaN') {
          this.amount = ''
        } else {
          this.amount = amount.decimalPlaces(8).toString()
        }
        if (this.amount === '0') {
          this.amount = ''
        }
        this.updateURI()
      }
    },
    fiatRate: {
      get () {
        return this.$store.state.fiatRate
      },
      set (value) {
        this.$store.commit('setFiatRate', value)
        this.updateURI()
      }
    },
    focused: {
      get () {
        return this.$store.state.focused
      },
      set (value) {
        this.$store.commit('setFocused', value)
      }
    },
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (value) {
      }
    },
    message: {
      get () {
        return this.$store.state.message
      },
      set (value) {
        this.$store.commit('setMessage', value)
        this.updateURI()
      }
    },
    nukumolink: {
      get () {
        return this.$store.state.nukumolink
      },
      set (value) {
      }
    },
    qrcode: {
      get () {
        return this.$store.state.qrcode
      },
      set (value) {
        this.$store.commit('setQRCode', value)
      }
    },
    uri: {
      get () {
        return this.$store.state.uri
      },
      set (value) {
        this.$store.commit('setURI', value)
        this.updateQRCode()
      }
    },
    useFiat: {
      get () {
        return this.$store.state.useFiat
      },
      set (value) {
        this.$store.commit('setUseFiat', value)
        this.updateURI()
      }
    }
  },
  watch: {
    fiatRate: function () {
      this.updateURI()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue